import { Component, ElementRef, HostBinding, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BaseModalComponent } from '../../../models/base-modal-component';
import { DrFilter } from '../../../models/dr-filter';
import { DrRequestInfo } from '../../../models/dr-request-info';
import { Endpoint, FilterAttribute, FilterOperator, HelpIndex, PasswordListType } from '../../../models/enums';
import { FilterTemplateType, GenericColDef, GridContext, SortByFilter } from '../../../models/grid-context';
import { CommonService } from '../../../services/common/common.service';
import { RestService } from '../../../services/rest/rest.service';
import { GenericGridComponent } from '../../generic-grid/generic-grid.component';
import { ObjectActionListType, Permissions } from '../../../models/permission';

@Component({
    standalone: false,
    selector: 'res-found-passwords-modal',
    templateUrl: './found-passwords-modal.component.html',
    styleUrls: ['./found-passwords-modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class FoundPasswordsModalComponent extends BaseModalComponent implements OnInit {
    @HostBinding('class') classes = 'maximized-component';
    @ViewChild(GenericGridComponent) foundPwdGrid: GenericGridComponent;
    @ViewChild('downloadFoundPasswordsLink', { read: ElementRef, static: true }) downloadLink: ElementRef;

    modalAutomationId = 'found-passwords-modal';
    modalClass = 'found-passwords-modal';
    modalTitle = 'View Found Passwords';
    modalHelpIndex = HelpIndex.password_view_found_passwords_dlg;
    requestInfo: DrRequestInfo;
    isBusy = false;
    isBusyMessage = '';
    handle: string;
    filterList: Array<DrFilter>;
    hasDownloadPermission: boolean;

    columnDefs = new Array<GenericColDef>({
        headerName: 'Password',
        field: 'password',
        automationId: this.modalAutomationId,
        defaultSortBy: SortByFilter.NAME,    //not actually used by backend just formally added it in order to show the sort icon
        filterType: FilterTemplateType.freeform,
        lockVisible: true,
        preserveSpaces: true
    });

    gridContext = new GridContext({
        inlineGridFilter: true,
        sortTypeEnabled: false,
        sortEnabled: false,
        sortAscending: true,
        sortBy: SortByFilter.NAME,
        sortByFieldName: 'sortByFilter',
        onFilterApply: (passwordName: string) => this.onFilterApply(passwordName),
    });

    constructor(private restService: RestService, private modalRef: BsModalRef,
        private modalService: BsModalService, private commonService: CommonService) {
        super(modalService, modalRef);
    }

    ngOnInit(): void {
        if (this.modalData?.handle) {
            this.handle = this.modalData.handle;
            this.requestInfo = {
                endpoint: Endpoint.projectManager_getPasswordList,
                responseName: 'passwordData',
                data: {
                    startIndex: 0,
                    count: 100,
                    passwordListType: PasswordListType.FOUND_PASSWORDS,
                    projectId: this.handle,
                    filters: [],
                    selectedAttributes: []
                }
            }
        }
        this.hasDownloadPermission = Permissions.checkUserPermission(ObjectActionListType.DOCUMENT_REPORTS);
    }

    downloadFoundPasswords(): void {
        this.restService.post(Endpoint.projectManager_downloadPasswordDataUrl, {
            projectId: this.handle, passwordListType: PasswordListType.FOUND_PASSWORDS, filters: this.filterList
        }).then((response) => {
            if (response?.viewManifestUrl) {
                this.commonService.unzipFile(response.viewManifestUrl, this.downloadLink.nativeElement, 'FoundPasswords');
            }
        });
    }

    closeModal(result?: boolean, data?: any): void {
        this.modalRef.hide();
    }

    onFilterApply(passwordName: string): void {
        if (passwordName && passwordName.trim() !== '') {
            this.filterList = new Array<DrFilter>(new DrFilter({
                attribute: FilterAttribute.PASSWORD,
                operator: FilterOperator.EQUALS,
                value: passwordName
            }));
        } else {
            this.filterList = [];
        }
        this.requestInfo.data.filters = this.filterList;
        this.foundPwdGrid.loadData();
    }
}
